module.exports = __webpack_public_path__ + "img/clothes-001.a19817d2.jpg";